import { j as e } from "./index.es33.js";
import { t as u } from "./index.es106.js";
import { Typography as h } from "./index.es35.js";
import "./index.es36.js";
import { VariableHeader as f } from "./index.es576.js";
import { OptionGroup as x } from "./index.es162.js";
import { Option as i } from "./index.es161.js";
import s from "./index.es577.js";
var j = function j(_ref) {
  var _ref$header = _ref.header,
    a = _ref$header === void 0 ? "" : _ref$header,
    _ref$options = _ref.options,
    o = _ref$options === void 0 ? [] : _ref$options,
    _ref$selectedValues = _ref.selectedValues,
    t = _ref$selectedValues === void 0 ? [] : _ref$selectedValues,
    _ref$onHeaderClick = _ref.onHeaderClick,
    n = _ref$onHeaderClick === void 0 ? function () {
      return null;
    } : _ref$onHeaderClick,
    _ref$onOptionClick = _ref.onOptionClick,
    m = _ref$onOptionClick === void 0 ? function () {
      return null;
    } : _ref$onOptionClick,
    _ref$noOptionsText = _ref.noOptionsText,
    p = _ref$noOptionsText === void 0 ? u("component_commonMessage_searchMessageLabel_noMatchingSearchMessageLabel") : _ref$noOptionsText,
    c = _ref.popupRef,
    d = _ref.popupPositionStyles;
  return e.jsxs("ul", {
    ref: c,
    className: s.popupMenu,
    style: d,
    children: [a && e.jsx(i, {
      className: s.headerOption,
      onClick: n,
      isSelected: !1,
      isDivided: !0,
      children: a
    }), !o.length && e.jsx("div", {
      className: s.noItemsContainer,
      children: e.jsx(h.Body2, {
        className: s.noItems,
        children: p
      })
    }), o.map(function (r) {
      return e.jsx(x, {
        label: r.title,
        children: r.items.map(function (l) {
          return e.jsx(i, {
            onClick: function onClick() {
              return m === null || m === void 0 ? void 0 : m(l);
            },
            isSelected: !!(t !== null && t !== void 0 && t.includes(l.value)),
            isPreWrap: !0,
            children: l.label
          }, l.value);
        })
      }, r.title);
    })]
  });
};
j.VariableHeader = f;
export { j as PopupMenu };